// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import React from "react";
import { useNavigate } from 'react-router-dom';
import { PlasmicPaymentsListCard } from "./plasmic/collect_wise_draft/PlasmicPaymentsListCard";
import PaidStatusCard from "./PaidStatusCard"
import NotPaidStatusCard from "./NotPaidStatusCard"
import VoidStatusCard from "./VoidStatusCard"

function PaymentsListCard_(props, ref) {
  const navigate = useNavigate()

  return <PlasmicPaymentsListCard root={{ ref,
  onClick: () => navigate(`payment/${props.id}`)
  }} {...props} 
  statusCardStack={{
    children: props.paymentVoided ? <VoidStatusCard/> : props.paidStatus === 'Paid' ? <PaidStatusCard/> : <NotPaidStatusCard/>
  }}
  />;
}

const PaymentsListCard = React.forwardRef(PaymentsListCard_);

export default PaymentsListCard;
